import dayjs from "dayjs";

import { JobCategory, User } from "@/api/generated";
import { AccountRegisterFormData } from "@/validations/account";
import { annualIncomeSchema } from "@/validations/annualIncome";

const hasValue = (value: string | number | null | undefined) => value != null && value !== "";
const formString = (saved: string | number | null | undefined, draft: string | null | undefined) =>
  hasValue(saved) ? String(saved) : draft ?? "";

export const getAccountPriorAnswers = (
  user: User,
  draft: Partial<AccountRegisterFormData>
): Partial<AccountRegisterFormData> => {
  const experience =
    typeof user.has_investment_experience === "boolean"
      ? user.has_investment_experience
      : typeof draft.has_investment_experience === "boolean"
        ? draft.has_investment_experience
        : undefined;
  const birthday = user.birthday ? dayjs(user.birthday) : null;
  const holdingPropertyCount = formString(user.holding_property_count, draft.holding_property_count);
  const realEstateLoanAmount = formString(user.real_estate_loan_amount, draft.real_estate_loan_amount);
  // 旧アプリの円単位入力は回答済みにせず、修正済みの下書きがあればそちらを使う。
  const annualIncome = [user.annual_income, draft.annual_income]
    .find((value) => annualIncomeSchema.safeParse(value == null ? "" : String(value)).success);

  return {
    has_investment_experience: experience,
    birth_year: birthday?.isValid() ? birthday.year() : draft.birth_year ?? null,
    birth_month: birthday?.isValid() ? birthday.month() + 1 : draft.birth_month ?? null,
    job_category: formString(user.job_category === JobCategory.入力なし ? "" : user.job_category, draft.job_category),
    job_industry: formString(user.job_industry, draft.job_industry) || null,
    job_continuous_period: formString(user.job_continuous_period, draft.job_continuous_period),
    annual_income: annualIncome == null ? "" : String(annualIncome),
    financial_asset: formString(user.financial_asset, draft.financial_asset),
    holding_property_count: holdingPropertyCount || (experience === false ? "0" : ""),
    real_estate_loan_amount: realEstateLoanAmount || (experience === false ? "0" : ""),
  };
};
